import { Close, DownloadOutlined, FilterAlt, ReplayCircleFilled, } from '@mui/icons-material'
import { Input, Table, Typography, Select, Button, Badge, Drawer, Checkbox, Divider, Space, Form, Tooltip, DatePicker } from 'antd'
import React, { useEffect, useState } from 'react'
import "../assets/styles/viewOrganisation.scss"
import { getListViewOrg, getFilteredOrg, getAllOrgName, getListAllCities, getFilteredOrgDocsDownload, getListViewOrgDocsDownload, getAof, getBillingsCaOrg, downloadSubBillings } from "../services/httpCalls"
import { useRecoilValue, useSetRecoilState } from 'recoil'
import { billingsOrgId, showloader } from "../store/gloabalState";
import useNotify from "../utils/useNotify";
import FileDownload from "js-file-download";
import { useNavigate } from "react-router-dom";
import { EyeOutlined, EditOutlined, FileSyncOutlined } from "@ant-design/icons"
import { Link } from "react-router-dom";
import { Box } from "@mui/system";

const SubTable = ({ hideSubtable }) => {
    const { RangePicker } = DatePicker;
    const [queryTermSearch, setQueryTermSearch] = useState('')
    const [billingsSub, setBillingsSub] = useState()
    const [filterRefresh, setFilterRefresh] = useState(false)
    const [querySearchRefresh, setQuerySearchRefresh] = useState(false)
    const [totalCount, setTotalCount] = useState(0)
    const [currentPage, setCurrentPage] = useState(0)
    const [form] = Form.useForm();
    const setShowLoader = useSetRecoilState(showloader);
    const selectedOrgId = useRecoilValue(billingsOrgId)
    const notify = useNotify()
    const navigate = useNavigate()

    const colsCa = [
        {
            title: "Completion Date",
            key: "date",
            align: "center",
            width: '10%',
            render: (val, record) => (
                record?.completionDate ? record.completionDate : ""
            ),
        },
        {
            title: "Vendor Name",
            key: "vendorName",
            align: "center",
            width: '20%',
            render: (val, record) => (
                record?.vendorName ? record.vendorName : ""
            ),
        },
        {
            title: "Initiation date",
            key: "startDate",
            align: "center",
            width: '10%',
            render: (val, record) => (
                record?.initiationDate ? record.initiationDate : ""
            ),
        },
        {
            title: "Transaction Amount",
            key: "amount",
            align: "center",
            width: '10%',
            render: (val, record) => (
                `${record?.currencyCode ? record.currencyCode : ""}` + " " +
                `${record?.amount ? record.amount : ""}`
            ),
        },
        {
            title: "Karbon 15CA/CB Charges",
            key: "charges",
            align: "center",
            width: '15%',
            render: (val, record) => (
                record?.ca15AndCb15Charges ? record.ca15AndCb15Charges : ""
            ),
        },
    ]

    async function getOrgBillings() {
        setShowLoader(true)
        await getBillingsCaOrg(selectedOrgId?.id, currentPage)
            .then((res) => {
                setBillingsSub(res?.transactions)
                setTotalCount(res?.totalCount)
            })
            .catch((err) => {
                notify.error("Error while getting billings!")
            })
            .finally(() => {
                setShowLoader(false)   
            })
             
    }

    const onTablePageChange = (pagination) => {
        setCurrentPage(pagination.current - 1)
    };

    const downloadDoc = async() => {
        setShowLoader(true)
        await downloadSubBillings(selectedOrgId.id)
        .then((res) => {
            FileDownload(res, "subtable.xlsx")
            notify("File downloaded successfully!")
        })
        .catch((err) => {
            notify("Error downloading file!")
        })
        .finally(() => {
            setShowLoader(false)
        })
    }

    useEffect(() => {
        if (selectedOrgId.id) {
            getOrgBillings()
        }
    }, [selectedOrgId, currentPage])

    return (
        <Box className="modal_wrap">
            <Box className="modal_in subtable" sx={{ padding: '1rem', borderRadius: '4px' }}>

                <div className='org_filters-container_wrapButtons'>
                    <Typography
                        className="modal_title"
                        // variant="h5"
                        style={{
                            color: "#4d4a4a",
                            letterSpacing: ".6px",
                            marginBottom: 2,
                            fontWeight: 600,
                            fontSize: "1rem"
                        }}
                    >
                        Sub table of {selectedOrgId.name ? selectedOrgId.name : selectedOrgId.id}
                    </Typography>
                    <div className='org_filters-container_downloadButton' style={{marginLeft:'auto'}}>
                        <Button type='primary' onClick={downloadDoc} icon={<DownloadOutlined />}>Download</Button>
                    </div>
                </div>
                <Box className="modal_content" >
                    <div className='org'>

                        {/* <div className="org_heading">
                            <Typography.Title level={2}>15CA/CB Report</Typography.Title>
                        </div> */}
                        <div className="org_filters-container" style={{
                            margin: "20px 0"
                        }}>
                            {/* <div className="org_filters-container_searchbox" style={{ margin: "15px 0" }}>
                                <Input style={{
                                    width: "300px",
                                    margin: "0 10px"
                                }} onChange={(e) => setQueryTermSearch(e.target.value)} placeholder='Search by Customer Name' value={queryTermSearch ? queryTermSearch : ""} />
                                <Button type='primary' onClick={() => {
                                    if (queryTermSearch) {
                                        setQuerySearchRefresh(!querySearchRefresh)

                                    }
                                    else {
                                        notify.error("Please enter PAN or GST to be searched!")
                                    }
                                }}>Search</Button>
                                <Tooltip title="Resets all the filter states and sync with original data">
                                    <Button icon={<ReplayCircleFilled />} type='ghost' style={{ margin: "0 5px" }} onClick={() => {
                                        form.resetFields()
                                        // setFilterValues({})
                                        setQuerySearchRefresh(!querySearchRefresh)
                                        setQueryTermSearch('')
                                        setCurrentPage(0)
                                    }}>RESET</Button>
                                </Tooltip>
                            </div> */}


                        </div>
                        <div className="org_table">
                            <Table columns={colsCa} dataSource={billingsSub} className='styledAntd' pagination={{
                                pageSize: 10,
                                total: totalCount,
                                showSizeChanger: false,
                                position: ["bottomCenter"],
                                current: currentPage + 1
                            }}
                                onChange={onTablePageChange}
                                rowKey={(record) => Math.random() + record?.transactionId}
                            // scroll={{ x: '100vw' }}
                            />
                        </div>

                    </div >
                </Box>
                <Box
                    className="modal_footer"
                    sx={{ padding: "1rem 0 0 !important", textAlign: "right" }}
                >
                    <Button
                        variant="outlined"
                        onClick={hideSubtable}
                    // sx={{
                    //     border: "1px solid #dc1d00",
                    //     color: "#dc1d00",
                    // }}
                    >
                        Cancel
                    </Button>
                </Box>
            </Box>
        </Box>

    )
}

export default SubTable
